interface SearchResultItemProps {
  title: string;
  type: 'topic' | 'document' | 'session' | 'video';
  createdAt?: string;
  onClick?: () => void;
}

const SearchResultItem = ({ title, type, createdAt, onClick }: SearchResultItemProps) => {
  // Helper function to format date (same as in Sidebar)
  const formatDate = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));
    if (diffInHours < 24) {
      return 'Today';
    } else if (diffInHours < 48) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }
  };

  return (
    <div 
      onClick={onClick}
      className="flex items-center justify-between px-6 py-3 hover:bg-gray-50 cursor-pointer transition-colors"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <span className="font-medium text-gray-800 truncate">
          {title}
        </span>
      </div>
      {createdAt && (
        <span className="text-xs text-gray-500 flex-shrink-0 ml-2">
          {formatDate(createdAt)}
        </span>
      )}
    </div>
  );
};

export default SearchResultItem;